export default {
  ENABLED: 'ENABLED',
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  DISABLED: 'DISABLED',
};
